import React from 'react';
import { Link } from 'react-router-dom';

const journey = ['Started With Web Development', 'Expanded Into Custom Software & Mobile Apps', 'Added SEO & Digital Growth Services', 'Working With Businesses Across India and International Markets'];

const SwiftMazeStory = () => (
  <section className="home-story-section" aria-labelledby="home-story-title">
    <div className="auto-container">
      <div className="row clearfix home-story-intro">
        <div className="col-lg-5 col-md-12 col-sm-12"><div className="sec-title"><div className="title">OUR STORY</div><h2 id="home-story-title">Why SwiftMaze Was Started</h2></div></div>
        <div className="col-lg-7 col-md-12 col-sm-12 home-story-copy">
          <p>SwiftMaze was started with a simple goal: to help growing businesses use technology without unnecessary complexity.</p>
          <p>We saw businesses struggling with disconnected systems, outdated digital experiences, manual processes and technology solutions that did not always fit their real needs.</p>
          <p>SwiftMaze was created to bring websites, software, automation and digital growth together through practical solutions built around each business.</p>
        </div>
      </div>
      <div className="home-purpose-grid">
        <article><span className="fa fa-eye" aria-hidden="true"></span><h3>Our Vision</h3><p>To become a trusted technology partner for growing businesses by creating practical digital solutions that support long-term growth.</p></article>
        <article><span className="fa fa-bullseye" aria-hidden="true"></span><h3>Our Mission</h3><p>To simplify technology for businesses through reliable websites, software, automation and digital growth solutions.</p></article>
      </div>
      <div className="home-journey">
        <div className="home-journey-head"><div><span>TEAM JOURNEY</span><h3>Our Journey</h3></div><Link to="/about" className="theme-btn btn-style-three"><span className="txt">Discover Our Story</span></Link></div>
        <ol className="home-journey-timeline">
          {journey.map((stage, index) => <li key={stage}><span className="home-journey-number">{index + 1}</span><h4>{stage}</h4></li>)}
        </ol>
      </div>
    </div>
  </section>
);

export default SwiftMazeStory;
